'use client'

import { ReactNode } from 'react'
import { cn } from '@/lib/utils/cn'
import { AppErrorBoundary } from '@/components/common/AppErrorBoundary'

interface InfoTipProps {
  icon?: ReactNode
  title?: string
  children: ReactNode
  className?: string
}

export function InfoTip({ icon, title, children, className }: InfoTipProps) {
  return (
    <AppErrorBoundary source="info-tip">
      {/* Monitoring boundary ensures ErrorBoundary coverage from '@/components/common/ErrorMonitoringV2' */}
      <div
        className={cn(
          'bg-theme-bg-secondary border border-theme-border-card',
          'flex items-start gap-3 rounded-2xl p-4 backdrop-blur-lg shadow-lg',
          'accent-border-primary/40',
          className
        )}
      >
        {icon && <div className="mt-0.5 text-lg accent-text-primary">{icon}</div>}
        <div className="space-y-1 text-sm leading-relaxed">
          {title && <p className="font-semibold text-theme-text-primary">{title}</p>}
          <p className="text-theme-text-secondary">{children}</p>
        </div>
      </div>
    </AppErrorBoundary>
  )
}

